import { render } from "./dokumenPerencanaan.vue?vue&type=template&id=5f19864c"
import script from "./dokumenPerencanaan.vue?vue&type=script&lang=js"
export * from "./dokumenPerencanaan.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__